import { FieldArray } from "formik";
import { Trash2Icon } from "lucide-react";
import { Badge, Button, Form } from "react-bootstrap";
import Select from "react-select";

export const PlantStageSections = ({
  item,
  index,
  formik,
  arrayHelpers,
  isFirst,
  BOM,
  reFreshBill,
  insideItem,
  Equipments,
}) => {
  const DisplayErrors = (name) => {
    const error = formik.errors?.items?.[index]?.[name];

    const touched = formik.touched?.items?.[index]?.[name];

    return touched && error ? (
      <p className="custom-invalid-feedback">{error}</p>
    ) : null;
  };

  const DisplayInsideErrors = (name, insideIndex) => {
    const error = formik.errors?.items?.[index]?.stages?.[insideIndex]?.[name];

    const touched =
      formik.touched?.items?.[index]?.stages?.[insideIndex]?.[name];

    return touched && error ? (
      <p className="custom-invalid-feedback">{error}</p>
    ) : null;
  };

  const selectedBOMs = formik.values?.items?.map((el) => el?.BOM) || [];

  const selectedSet = new Set(selectedBOMs);

  const availableBOMs = BOM.filter(({ value }) => !selectedSet.has(value));

  const selectedEQ = item?.stages?.map((it) => it?.equipment || []);

  const selectedEQSet = new Set(selectedEQ);

  const availableEquipments = Equipments.filter(
    ({ value }) => !selectedEQSet.has(value),
  );

  //   console.log(item);

  return (
    <div key={index} className="border rounded p-3 mb-4">
      <div className="d-flex justify-content-between mb-3">
        <h5>{item?.active && <Badge bg={"success"}>Active</Badge>}</h5>

        {formik.values.items.length > 1 && (
          <Button
            variant="danger"
            size="sm"
            onClick={() => arrayHelpers.remove(index)}
          >
            Remove
          </Button>
        )}
      </div>

      <div className="row">
        <Form.Group className="col-12 mb-3">
          <Form.Label className="mb-1">Select Bill of Materials</Form.Label>
          <Select
            classNamePrefix={"form-select"}
            isSearchable={true}
            name="BOM"
            value={BOM.find((el) => el.value === item.BOM)}
            onChange={({ value, label }) => {
              formik.setFieldValue(`items.${index}.BOM`, value);
              formik.setFieldValue(`items.${index}.BOMName`, label);
            }}
            options={availableBOMs}
            isDisabled={item?.active}
          />

          {DisplayErrors("BOM")}
        </Form.Group>

        <FieldArray
          name={`items.${index}.stages`}
          render={(insideArrayHelpers) => (
            <>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns:
                    "repeat(auto-fit, minmax(min(400px, 100%), 1fr))",
                  gap: "30px",
                }}
              >
                {item?.stages?.map((stageItem, insideIndex) => (
                  <div key={insideIndex} className="border rounded p-3 mb-4 ">
                    <div className="d-flex justify-content-between mb-3">
                      <h6>Stage #{insideIndex + 1}</h6>

                      {item?.stages?.length > 1 && (
                        <Button
                          variant="danger"
                          size="sm"
                          onClick={() => insideArrayHelpers.remove(insideIndex)}
                          disabled={item?.active}
                        >
                          <Trash2Icon color="white" size={20} />
                        </Button>
                      )}
                    </div>

                    <div className="row my-3">
                      <Form.Group className="col-6 mb-3">
                        <Form.Label className="mb-1">Name</Form.Label>
                        <Form.Control
                          placeholder="Enter stage Name"
                          value={stageItem.name}
                          name={`items.${index}.stages.${insideIndex}.name`}
                          onChange={formik.handleChange}
                          disabled={item?.active}
                        />
                        {DisplayInsideErrors("name", insideIndex)}
                      </Form.Group>

                      <Form.Group className="col-6 mb-3">
                        <Form.Label className="mb-1">
                          Select Equipment
                        </Form.Label>
                        <Select
                          classNamePrefix={"form-select"}
                          isSearchable={true}
                          value={Equipments.find(
                            (el) => el.value === stageItem.equipment,
                          )}
                          onChange={({ value, label }) => {
                            formik.setFieldValue(
                              `items.${index}.stages.${insideIndex}.equipment`,
                              value,
                            );
                            formik.setFieldValue(
                              `items.${index}.stages.${insideIndex}.equipmentName`,
                              label,
                            );
                          }}
                          options={availableEquipments}
                          isDisabled={item?.active}
                        />

                        {DisplayInsideErrors("equipment", insideIndex)}
                      </Form.Group>
                    </div>
                  </div>
                ))}
              </div>

              <div className="d-flex justify-content-end">
                <Button
                  variant="outline-primary"
                  onClick={() =>
                    insideArrayHelpers.push({
                      ...insideItem,
                    })
                  }
                >
                  Add New Stage
                </Button>
              </div>
            </>
          )}
        />
      </div>
    </div>
  );
};
